export default {
  sell: getState("SELL"),
  rmId: getState("SELL_RM_ID"),
  sellSave: getState("SELL_SAVE"),
  modalAddCustomer: false,
  loading: false
}
function getState(key) {
  return JSON.parse(localStorage.getItem(key))
}
